import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { SystemPopup } from '@gongxigames/framework/slot/types';
import { SingleSetPromotionLogic, SingleSetPromotionStates, SingleSetPromotionModule } from '@gongxigames/framework/promotions';

export class SingleSetPromotionStartState extends ModuleState<null, SingleSetPromotionModule, GlobalEventsMapForBackwardCompatibility> {
    private popup!: SystemPopup;

    public onEnterState(): void {
        this.emit('General.Slot.SPIN.DISABLE', SingleSetPromotionModule.NAME);
        this.emit('General.UI.DISABLE', SingleSetPromotionModule.NAME);
        this.emit('Autoplay.FORCE_STOP');
        this.showStartPopup();
    }

    public onLeaveState(): void {
        this.emit('General.Slot.SPIN.ENABLE', SingleSetPromotionModule.NAME);
        this.emit('General.UI.ENABLE', SingleSetPromotionModule.NAME);
        this.module.hidePopup(this.popup);

        if (this.module.getPromotion().isActive()) {
            this.emit('General.Promotion.Started');
        }
    }

    private onClickAccept(): void {
        this.hidePopupAndDisableUI();
        this.module.getPromotion<SingleSetPromotionLogic>().accept(this.onAcceptProcessed.bind(this));
    }

    private onClickAskMeLater(): void {
        this.hidePopupAndDisableUI();
        this.module.getPromotion<SingleSetPromotionLogic>().reject(this.onRejectProcessed.bind(this));
    }

    private onAcceptProcessed(): void {
        this.module.gotoState(SingleSetPromotionStates.IN_PROGRESS);
    }

    private onRejectProcessed(): void {
        this.emit('General.Promotion.Ended');
        this.module.gotoState(SingleSetPromotionStates.DISABLED);
    }

    protected hidePopupAndDisableUI(): void {
        this.module.hidePopup(this.popup);
        this.emit('General.UI.DISABLE', SingleSetPromotionModule.NAME);
    }

    private showStartPopup(): void {
        this.popup = this.module.popups.createSingleSetStartPopup({
            onClickAccept: this.onClickAccept.bind(this),
            onClickAskMeLater: this.onClickAskMeLater.bind(this),
            ...this.module.getPromotion<SingleSetPromotionLogic>().getData(),
        });
        this.module.showPopup(this.popup);
    }

    protected setupEvents(): void {}
}
